// See https://developer.matomo.org/api-reference/tracking-javascript
export default class MatomoTracker {
  static isReady() {
    return !!(window.top.Matomo && window.top.ENV && window.top.ENV.matomo);
  }

  static trackGoal(id) {
    if (!this.isReady()) return false;

    this.getTracker().trackGoal(id);
  }

  static getTracker() {
    return window.top.Matomo.getTracker(
      window.top.ENV.matomo.url,
      window.top.ENV.matomo.siteId
    );
  }
}
